import { Flex, Icon, Skeleton, Text } from "components/common"
import { Separator, TitleDescription } from "components/custom"
import { CLIENT_DETAIL_PATH } from "constants/app-paths"
import { t } from "i18next"
import { Link } from "react-router-dom"
import { joinBytItems, localisedValue } from "utils"
import { PAGE_SUBSECTIONS } from "utils/gtm/gtmEventsData"
import theme from "utils/themeVars"
import { formatPaymentLineAmountForInput } from "features/leads/components/addSalesModal/components/addSalesForm/components/paymentSection/utils/paymentUtils"
import { FRACTIONAL_PAYMENT_CHANNEL_PSID, FRACTIONAL_PAYMENT_CHANNEL_STANDARD } from "../fractionalPaymentUtils"

export const modalTitle = (lead, client, isFiler = undefined) => {
  const title = t("Add Sale")
  const clientName = localisedValue({ object: lead?.Client || client, key: "name" }) || lead?.name
  const description = joinBytItems(
    [
      <Text type="secondary">
        {clientName} {isFiler === undefined ? "" : isFiler ? `(${t("Filer")})` : `(${t("Non Filer")})`}
      </Text>,
      <Link
        to={CLIENT_DETAIL_PATH.replace(":clientId", lead?.Client?.id)}
        state={{ hasPath: true, from: PAGE_SUBSECTIONS.lead_listing_page }}
        className="text-link"
        target={"_blank"}
        style={{ color: theme["accent-color"] }}
        rel={"noopener noreferrer"}
      >
        {lead?.id}
      </Link>,
    ],
    <Separator />
  )
  return (
    <TitleDescription
      title={title}
      titleClassName="bold"
      titleProps={{ style: { fontSize: 16 } }}
      gapSpace={4}
      description={description}
    />
  )
}

export const renderBlocksHeader = () => {
  return (
    <Flex justify="space-between" className={"mbe-4"}>
      <Text type="secondary">{t("Add Property Blocks")}</Text>
      <div>
        {" "}
        <Text type="secondary">{t("Powered by")}</Text>{" "}
        <Icon icon="MyZameenLogo" style={{ fill: "#222", width: 70, height: 14 }} />
      </div>
    </Flex>
  )
}

export function FractionalSaleModalSkeleton() {
  const fieldRow = key => (
    <div key={key} style={{ marginBottom: 20, width: "100%" }}>
      <div style={{ marginBottom: 10 }} className="mbe-4">
        <Skeleton type="label" width="38%" active />
      </div>
      <Skeleton type="input" height={36} active />
    </div>
  )

  return (
    <div style={{ width: "100%", boxSizing: "border-box", paddingTop: 4 }}>
      {fieldRow("project")}
      <Skeleton height={88} active style={{ marginBottom: 16, borderRadius: 10 }} />
      <Skeleton height={140} active style={{ marginBottom: 16, borderRadius: 8 }} />
      <Skeleton height={200} active style={{ borderRadius: 8 }} />
    </div>
  )
}

export const instructions = () => [
  t("Log in to your bank's mobile app or digital wallet."),
  t("Go to") + " " + t("Bill Payments") + " -> " + t("KuickPay") + " " + t("section."),
  t("Enter your PSID number."),
  t("Verify the details shown, then confirm the payment to complete the transaction."),
]

export { PSID_INFO, psidAlertStyle } from "./psidInfo"

export {
  FRACTIONAL_SALE_CLIENT_REQUIRED_FIELDS,
  FRACTIONAL_SALE_DEFAULT_FORM_VALUES,
  canFetchFractionalPartnerFees,
  computeFractionalBlocksTotal,
  computeFractionalGrandTotal,
  findSelectedFractionalProject,
  formatFractionalSaleAmount,
  isPaymentProofOcrEnabledForFractionalProject,
  isPaymentProofVisionOnProject,
  isRaFlowEnabledForFractionalProject,
  partnerFeeTotalFromFeeData,
  taxTotalFromFeeData,
} from "./fractionalSaleCalculations"

export function fractionalDepositByRadioOptions(disableRA = false) {
  return [
    { key: false, name: t("Client") },
    { key: true, name: t("RA"), disbaled: disableRA },
  ]
}

export const channelOptions = () => [
  { label: t("Upload Payment Proof"), value: FRACTIONAL_PAYMENT_CHANNEL_STANDARD },
  { label: t("PSID"), value: FRACTIONAL_PAYMENT_CHANNEL_PSID },
]


export function freshFractionalPaymentRowAfterChannelToggle(roundedAmount) {
  const row = { enableDepositRA: false, enableRA: false }
  if (Number.isFinite(roundedAmount) && roundedAmount > 0) {
    row.amount = formatPaymentLineAmountForInput(roundedAmount)
  }
  return row
}
